module.exports = __webpack_public_path__ + "img/selected-favorite_97515.png";